import { hotTopics } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="hero" className="relative pt-16">
      <div className="mx-auto max-w-7xl px-4 pb-12 pt-8 md:px-6 md:pb-16 md:pt-12">
        <div className="grid items-center gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          {/* left intro */}
          <div className="relative">
            <div className="absolute -left-4 -top-8 h-24 w-24 rounded-full bg-accent-500/15 blur-2xl"></div>
            <div className="absolute bottom-0 right-10 h-24 w-24 rounded-full bg-secondary-500/20 blur-2xl"></div>

            <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700">
              <span className="h-2 w-2 animate-pulseSoft rounded-full bg-primary-500"></span>
              实时更新 · 网罗全网新鲜瓜
            </span>

            <h1 className="font-display mt-5 text-4xl leading-tight text-foreground-950 md:text-6xl md:leading-[1.15]">
              今天，又有什么
              <span className="relative inline-block px-2 text-primary-600">
                新瓜
                <span className="absolute inset-x-2 bottom-1 h-3 -z-10 rounded-sm bg-secondary-300/70"></span>
              </span>
              可以吃？
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
              明星动态、网红生态、综艺热梗、社会趣闻，色瓜网每天为你滚动整理当下最热门的讨论与新鲜猛料。锁定频道，不错过任何一场好戏。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#feed"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始吃瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#trend"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-200 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                查看热度排行
              </a>
            </div>

            <div className="mt-9 grid max-w-md grid-cols-3 gap-4">
              {[
                { num: "1.2万+", label: "全网热点聚合" },
                { num: "24h", label: "全天滚动更新" },
                { num: "4 大", label: "内容栏目" },
              ].map((s) => (
                <div key={s.label} className="border-l-2 border-primary-500/30 pl-3">
                  <p className="font-display text-2xl text-foreground-950">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* right trending board */}
          <div className="relative">
            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5 md:p-6">
              <div className="mb-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-fire-fill"></i>
                  </span>
                  <div>
                    <h2 className="font-display text-xl text-foreground-950">今日热搜</h2>
                    <p className="text-[11px] text-foreground-500">刚更新 · 点击热度实时波动</p>
                  </div>
                </div>
                <a href="#trend" className="text-xs font-medium text-primary-600 hover:underline">
                  完整排行
                </a>
              </div>

              <ul className="divide-y divide-background-200/70">
                {hotTopics.slice(0, 6).map((t) => (
                  <li key={t.rank}>
                    <a
                      href="#feed"
                      className="group flex items-center gap-3 py-3"
                    >
                      <span
                        className={`w-5 shrink-0 text-center font-display text-lg ${
                          t.rank <= 3 ? "text-primary-500" : "text-foreground-400"
                        }`}
                      >
                        {t.rank}
                      </span>
                      <span
                        className={`whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-bold text-background-50 ${t.levelColor}`}
                      >
                        {t.level}
                      </span>
                      <span className="flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                        {t.title}
                      </span>
                      <span className="hidden items-center gap-1 text-xs text-foreground-400 sm:flex">
                        <i className="ri-fire-line text-primary-400"></i>
                        {t.heat.split("热度")[0]}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>

              <p className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-time-line"></i>
                数据每 5 分钟自动刷新一次
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}